import {
  Http
} from '@/model/Http.js'

export default class withdraw extends Http {
  // 最近一次提现记录
  getWithdrawInfo(data){
    const url = 'api/shouto-platform-withdraw/get-withdraw-info'
    return this.postAjax(url, {
      ...data
    })
  }
  //提现记录
  getWithdrawList(data) {
    const url = 'api/shouto-platform-withdraw/search'
    return this.postAjax(url, {
      ...data
    })
  }

  //提现申请
  insertWithdrawRecord(data) {
    const url = 'api/shouto-platform-withdraw/add'
    return this.postAjax(url, {
      ...data
    })
  }

  //获取真实姓名
  getRealInfo(data){
    const url = 'api/shouto-platform-withdraw/get-info'
    return this.postAjax(url, {
      ...data
    })
  }
  /**
 * 短信验证码
 */
  smsSend(data){
    const url = 'api/shouto-platform-withdraw/getCode'
    return this.postAjax(url, {
      ...data
    })
  }
}




// WEBPACK FOOTER //
// ./src/javaApi/withdraw.js